var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1939 12.9734C10.6105 12.9734 10.1493 13.4267 10.1493 14.0001C10.1493 14.5601 10.6105 15.0267 11.1939 15.0267H19.3334V21.4001C19.3334 24.6667 16.6338 27.3334 13.2966 27.3334H6.69C3.36636 27.3334 0.666748 24.6801 0.666748 21.4134V6.60008C0.666748 3.32008 3.37993 0.666748 6.70357 0.666748H13.3237C16.6338 0.666748 19.3334 3.32008 19.3334 6.58675V12.9734H11.1939ZM24.1737 9.38702L28.067 13.267C28.267 13.467 28.3737 13.7203 28.3737 14.0003C28.3737 14.267 28.267 14.5337 28.067 14.7203L24.1737 18.6003C23.9737 18.8004 23.707 18.907 23.4537 18.907C23.187 18.907 22.9203 18.8004 22.7203 18.6003C22.3203 18.2003 22.3203 17.547 22.7203 17.147L24.8537 15.027H19.3337V12.9737H24.8537L22.7203 10.8537C22.3203 10.4537 22.3203 9.80035 22.7203 9.40035C23.1203 8.98701 23.7737 8.98701 24.1737 9.38702Z",
    fill: "#3C4564"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.746a230b.svg";
export { ForwardRef as ReactComponent };